import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PaymentService {
  urlGateway = environment.api_gateway;

  constructor(
    private http: HttpClient
  ) { }

  payOrder(orderId, params = {}): Observable<any> {
    return this.http.post<any>(`${this.urlGateway}/api/orders/payment/v1/${orderId}`, params);
  }

}
